import React, { Component, Fragment } from 'react';
import { Select, MenuItem, FormControl } from "@material-ui/core";
import { arrayOf, string, func, shape, node, bool, any } from 'prop-types';

import styles from "./styles.scss";

export class SelectComponent extends Component {

    static propTypes = {
        listItem: arrayOf(shape({
            label: string,
            icon: node
        })),
        value: shape({
            label: string,
            icon: node
        }),
        onChange: func,
        className: string,
        disabled: bool,
        classes: shape({any}),
    }

    static defaultProps = {
        listItem: [],
        value: {}
    }

    handleOnChange = event => {
        const value = event.target.value;
        this.props.onChange && this.props.onChange(value);
    }

    renderValue = (value) => {
        const { disabled } = this.props;
        return (
            <div className={disabled ? styles.renderDisabledValue : styles.renderValue}>
                {value.icon ?
                    <Fragment>{value.icon} &nbsp; {value.label}</Fragment>
                    :
                    value.label
                }
            </div>
        )
    }

    render() {
        const { listItem, value, className, disabled, classes } = this.props;
        const listItemMenu = listItem.map(item => (
            <MenuItem key={item.label} value={item} data-test={"menuItem_" + item.label}>{item.label || ""}</MenuItem>
        ));
        return (
            <FormControl className={className} disabled={disabled}>
                <Select
                    className={disabled ? styles.selectDisabledBox : styles.selectBox}
                    value={value}
                    renderValue={this.renderValue}
                    onChange={this.handleOnChange}
                    inputProps={{
                        classes: {
                          icon: classes.arrowDownIcon,
            
                        }
                    }}
                    data-test="listItemMenu"
                >
                    {listItemMenu}
                </Select>
            </FormControl>
        );
    }
}

import { withStyles } from '@material-ui/core/styles';

const useStyles = {
    arrowDownIcon: {
      color: '#2196f3'
    }
}

export default withStyles(useStyles)(SelectComponent);
